/**
 * 千分位格式化
 * @param value
 * @returns
 */
export function thousandFormatter(value: string | number): string {
  return value.toString().replace(/\d+/, n => n.replace(/(\d)(?=(\d{3})+$)/g, $1 => $1 + ','));
}

/**
 * 千分位字符串还原为数值
 * @param value
 * @returns
 */
export function thousandSeparatorRecover(value: string): number {
  return parseFloat(value.replace(/[^\d.-]/g, ''));
}

/**
 * input event 数字格式化
 */
export function numberFormat(val: string): string {
  let value = onTrim(val);
  value = value.replace(/[^\d.]/g, '');
  //必须保证第一位为数字而不是.
  value = value.replace(/^\./g, '');
  //保证只有出现一个.而没有多个.
  value = value.replace(/\.{2,}/g, '.');
  //保证.只出现一次，而不能出现两次以上
  value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  return value;
}

/**
 * 只能输入数字，包括负号，小数点都不可输入
 */
export function onlyNumberFormat(val: string): string {
  const value = numberFormat(`${val}`);
  return value.replace(/\D/g, '');
}

/**
 * 对象转formdata
 * @param data
 */
export const getFormDataByJson = (data: any): FormData => {
  const result = new FormData();
  for (const key in data) {
    if (data[key] instanceof Blob) {
      // blob特殊处理
      const value = data[key];
      const type = value.type;
      const time = new Date().getTime();
      result.append(key, value, value?.name ?? `${time}.${type.replace(/^image\//g, '')}`);
    } else {
      result.append(key, data[key]);
    }
  }
  return result;
};

/**
 * 去除空白且前后空格
 * @param {boolean} includeInside 判断是否去除所有空格
 * @param {boolean} isTrim 是否去前后空格
 */
export const onTrim = (value: string, options = {}): string => {
  const _options = {
    includeInside: false,
    isTrim: true,
    ...options,
  };
  const _val = _options.isTrim ? value.trim() : value;
  return _options.includeInside ? _val.replace(/\s/gi, '') : _val.replace(/\s+/gi, ' ');
};

// /**
//  * 拼音，字母自动格式化
//  * @param value
//  */
// export const onFormatPinyin = (value: string, options = {}): string => {
//   const _options = {
//     isNeedToUpperCase: false,
//     ...options,
//   };
//   const _val = value.replace(/^\s/, '').replace(/( )+|[^a-zA-Z]+/gi, '$1');
//   return _options.isNeedToUpperCase ? _val.toUpperCase() : _val;
// };

// /**
//  * 身份证
//  * 香港开户判断 （"括号"、"字母"、"数字"）(中文括号转换成英文括号)
//  * 默认只限制输入"数字" xX
//  * @param value
//  * @param isHK
//  * @returns
//  */
// export const onFormatIdCardNo = (value: string, isHK?: boolean): string => {
//   if (!isHK) {
//     return value
//       .replace(/[^0-9xX]/gi, '')
//       .toUpperCase()
//       .replace(/\d{6}/, '$& ')
//       .replace(/(\d|\s){15}/, '$& ')
//       .trim();
//   }
//   return value
//     .replace(/[^0-9A-Za-z()（）]/gi, '')
//     .replace(/（/g, '(')
//     .replace(/）/g, ')')
//     .toUpperCase();
// };

// /**
//  * 格式化成数字
//  * @param value
//  * @returns
//  */
// export const onFormatterNumber = (value: string): string => value.replace(/[^0-9]/gi, '');

/**
 * 驼峰 => 小写 + 横杠
 * 输入 - grayVersion
 * 输出 - gray-version
 * @param {string} value 驼峰字符串
 * @param {boolean} options[isToLowerCase] 是否需要转小写 默认 true
 * @param {string} options[separator] 需要分割的字符串 默认 -
 * @returns {string}
 */
export function onFormatKebabCase(value: string, options = {}) {
  const _options = {
    isToLowerCase: true,
    separator: '-',
    ...options,
  };
  return value.replace(/[A-Z]/g, item => {
    return `${_options.separator}${_options.isToLowerCase ? item.toLowerCase() : item}`;
  });
}

/**
 * 小写 + 横杠 => 驼峰
 * 输入 - grayVersion
 * 输出 - gray-version
 * @param {string} value 驼峰字符串
 * @param {boolean} options[isToUpperCase] 是否需要转小写 默认 true
 * @returns {string}
 */
export function onCamelCase(value: string, options = {}) {
  const _options = {
    isToUpperCase: true,
    ...options,
  };
  return value.replace(/-([a-z])/g, item => {
    return `${_options.isToUpperCase ? item.toUpperCase() : item}`;
  });
}
